import React, {useState, useEffect} from 'react';
import {Box, Button, IconButton,Table, TableBody, TableCell, TableRow} from "@mui/material";
import Strings from "../../assets/strings";
import {agregarEditarCliente} from "../../redux/reducers/clientesReducer";
import {Launch} from "@mui/icons-material";
import {HtmlTooltip} from "../../components";
import {ICliente} from "../../redux/types/ICliente";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";

export default function ClienteUsuario({cliente}:{cliente:ICliente}) {
    const [passFocus,setPassFocus]=useState(false)
    const [pass,setPass]=useState("")
    const Dispatch = useAppDispatch()
    const user = useAppSelector(state=>state.auth?.user?.inicioSesion)
    useEffect(()=>{
        setPass(cliente?.loginPass??"")
    },[setPass,cliente])

    const generar = () => {
        let cli = {...cliente,loginPass:pass}
        delete cli.avatar;
        delete cli.archivos;

        Dispatch(agregarEditarCliente({cliente:cli}))

    }
  return(
      <Box sx={{mb:2}}>
          <Box sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#ececec",
              mt:1,
              pl: 1,
              minHeight:37
          }}>
              <div>Ver estado de cuenta:</div>
              {(!!pass && pass !== cliente?.loginPass) ?(
                  <Button onClick={generar}>{Strings.guardar}</Button>
              ):(
                  <HtmlTooltip title={Strings.abrir}>
                      <IconButton size={"small"} color={"secondary"} sx={{mr:0.5}} component={"a"}
                                  target={"_blank"} rel="noopener noreferrer"
                                  href={`${window.location.origin}/estadoCliente/${user}`}
                      ><Launch/></IconButton>
                  </HtmlTooltip>
              )}
          </Box>

          <Box p={1}>
              <Table className={"noHover"} size={"small"}>
                  <TableBody>
                      <TableRow>
                          <TableCell>{Strings.cedula}:</TableCell>
                          <TableCell><input style={{border: "1px solid #ececec",marginLeft: 7,padding:5}} disabled value={cliente?.cedula} /></TableCell>
                      </TableRow>
                      <TableRow>
                          <TableCell>PIN / {Strings.contrasena}: </TableCell>
                          <TableCell>
                              <input onFocus={()=>setPassFocus(true)}
                                     onBlur={()=>setPassFocus(false)}
                                     autoComplete="off"
                                     type={"text"}
                                     style={{border: "1px solid #ececec",marginLeft: 7,padding:5}} max={6}
                                     value={passFocus ? pass ?? "" :"****"}
                                     onChange={e=>setPass(e.target.value)}
                              />
                          </TableCell>
                      </TableRow>
                  </TableBody>
              </Table>
          </Box>
      </Box>
  )
}
